<template>
  <div>
    <div class="reservations-table-container">
      <notification-new-booking></notification-new-booking>
      <div v-if="itemsToShow.length > 0 && !isFetchingData" class="reservations-table-wrapper">
        <transition name="slide-up">
          <div class="infinity-loader" v-show="scrollLoading">
            <i class="fas fa-spinner fa-spin"></i> Loading
          </div>
        </transition>
        <table id="rsvp-table-container" :class="{'has-paging':totalPages > 1, 'shrink':shrink}" @scroll="onScroll">
          <thead v-show="!isMobile">
            <tr class="table-header">
              <th class="rc-1">
                <input type="checkbox" v-model="checkedAll" />
              </th>
              <th class="rc-2"></th>
              <th class="rc-3"></th>
              <th v-bind:class="'sortable rc-4' + (isSorting ? ' disabled' : '')" @click="sort('r.ID')">
                <span>{{ $t('dispatch.rsvpTable.id') }}</span>
                <span v-show="rsvpSort.order === 'r.ID'">
                  <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
                </span>
              </th>

              <th v-bind:class="'sortable rc-5' + (isSorting ? ' disabled' : '')" @click="sort('cb.status')" v-show="!shrink">
                <span>{{ $t('dispatch.rsvpTable.status') }}</span>
                <span v-show="rsvpSort.order === 'cb.status'">
                  <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
                </span>
              </th>

              <th v-bind:class="'sortable rc-6' + (isSorting ? ' disabled' : '')" @click="sort('cb.pickupTime')" v-show="!shrink">
                <span>{{ $t('dispatch.rsvpTable.pickupTime') }}</span>
                <span v-show="rsvpSort.order === 'cb.pickupTime'">
                  <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
                </span>
              </th>

              <th class="rc-7" v-show="!shrink">{{ $t('dispatch.rsvpTable.pickup') }}</th>
              <th class="rc-7-2" v-show="!shrink">{{ $t('dispatch.rsvpTable.dropoffTime') }}</th>
              <th class="rc-8" v-show="!shrink">{{ $t('dispatch.rsvpTable.dropoff') }}</th>

              <th v-if="!isShort && !shrink" v-bind:class="'rc-9' + (isSorting ? ' disabled' : '')">
                <span>{{ $t('dispatch.rsvpTable.customer') }}</span>
                <span v-show="rsvpSort.order === 'CfirstName'">
                  <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
                </span>
              </th>

              <th v-if="!isShort && !shrink" class="rc-10">FARE<br/>AMOUNT</th>

              <th v-if="!isShort && !shrink" v-bind:class="'sortable rc-11' + (isSorting ? ' disabled' : '')" @click="sort('PfirstName')">
                <span>{{ $t('dispatch.rsvpTable.driver') }}</span>
                <span v-show="rsvpSort.order === 'PfirstName'">
                  <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
                </span>
              </th>

              <th class="rc-12" v-show="!shrink && showDriverPayment">DRIVER<br/>PAYMENT</th>

              <th v-bind:class="'sortable rc-13' + (isSorting ? ' disabled' : '')" @click="sort('st.name')" v-show="!shrink">
                <span>{{ $t('dispatch.rsvpTable.serviceType') }}</span>
                <span v-show="rsvpSort.order === 'st.name'">
                  <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
                </span>
              </th>

              <th v-if="!isShort && !shrink" class="rc-14">{{ $t('dispatch.rsvpTable.pickupType') }}</th>
              <th class="rc-15" v-show="!shrink"></th>
              <th class="rc-16" v-show="!shrink">{{ $t('dispatch.rsvpTable.flight') }}</th>
              <th v-if="!isShort && !shrink" class="rc-17">{{ $t('dispatch.rsvpTable.ada') }}</th>

              <th v-bind:class="'sortable rc-18' + (isSorting ? ' disabled' : '')" @click="sort('cb.passengers')" v-show="!shrink">
                <span>PAX</span>
                <span v-show="rsvpSort.order === 'cb.passengers'">
                  <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
                </span>
              </th>

              <th v-bind:class="'sortable rc-19' + (isSorting ? ' disabled' : '')" @click="sort('cb.luggage')" v-show="!shrink">
                <span>LUGGAGE/<br/>STOPS</span>
                <span v-show="rsvpSort.order === 'cb.luggage'">
                  <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                  <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
                </span>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr class="tr-loader" v-if="isPageLoading">
              <td :colspan="[shrink ? '4' : '19']">
                <div class="table-loader">
                  <ellipsis-loader></ellipsis-loader>
                  <div class="loader-title">{{ $t('dispatch.rsvpTable.loadingData.title') }}</div>
                </div>
              </td>
            </tr>
            <reservation-row v-for="(rsvp, index) in itemsToShow" :rsvp="rsvp"
              :isShort="isShort" :shrink="shrink" :key="index" v-if="!isPageLoading" :isMobile="isMobile"></reservation-row>

          </tbody>
        </table>

        <div id="rsvp-div" @scroll="onScroll">
          <div v-for="(rsvp, index) in itemsToShow" :key="index" v-if="!isPageLoading">
           {{ rsvp.id }}
          </div>
        </div>

        <!-- <div v-bind:class="{ paging: true, disabled: isPageLoading }"
              v-show="totalPages > 1">
          <a v-bind:class="{
               'page page-btn back': true,
               disabled: currentPage === 1
            }" href="javascript:;" @click="pageBtn(false)">
            <i v-bind:class="{
              'fas fa-fw': true,
              'fa-chevron-left': !isLoadingBack,
              'fa-spinner fa-spin': isLoadingBack
            }"></i>
          </a>
          <select class="page page-number" v-model.number="currentPage" @change="loadPage">
            <option v-for="n in totalPages" :value="n">{{ n }}</option>
          </select>
          <a v-bind:class="{
               'page page-btn next': true,
               disabled: currentPage === totalPages
            }" href="javascript:;" @click="pageBtn(true)">
            <i v-bind:class="{
              'fas fa-fw': true,
              'fa-chevron-right': !isLoadingNext,
              'fa-spinner fa-spin': isLoadingNext
            }"></i>
          </a>
        </div> -->
      </div>

      <div class="empty-reservations" v-show="itemsToShow.length <= 0 && !isFetchingData">
        <arrow-up></arrow-up>
        <div class="title">{{ emptyData.title }}</div>
        <div class="content">{{ emptyData.content }}</div>
      </div>
      <div class="table-loader" v-show="isFetchingData">
        <ellipsis-loader></ellipsis-loader>
        <div class="loader-title">{{ $t('dispatch.rsvpTable.loadingData.title') }}</div>
        <div class="loader-text">{{ $t('dispatch.rsvpTable.loadingData.content') }}</div>
      </div>
    </div>
    <reservation-controls :shrink="shrink"></reservation-controls>
  </div>
</template>

<script>
import ArrowUp from '@/components/Partials/LoadingAnimation/ArrowUp'
import EllipsisLoader from '@/components/Partials/LoadingAnimation/Ellipsis'
import ReservationControls from './ReservationControls'
import ReservationRow from './ReservationRow'
import NotificationNewBooking from './NotificationNewBooking'
import ApiDispatchReservation from '@/modules/api/dispatch/reservations'

export default {
  name: 'reservations-table',
  components: {
    ArrowUp, EllipsisLoader, ReservationControls,
    ReservationRow, NotificationNewBooking
  },
  props: [ 'isShort', 'shrink' ],
  data () {
    return {
      isPageLoading: false,
      isLoadingNext: false,
      isLoadingBack: false,
      isSorting: false,
      scrollLoading: false,
      isMobile: false
    }
  },
  computed: {
    itemsToShow () { return this.$store.state.dispatch.rsvpInTable },
    isFetchingData () { return this.$store.state.dispatch.fetching },
    emptyData () {
      let self = this
      let noDataFound = self.$store.state.dispatch.noDataFound

      if (noDataFound) {
        return {
          title: self.$t('dispatch.rsvpTable.noData.title'),
          content: self.$t('dispatch.rsvpTable.noData.content')
        }
      }

      return {
        title: self.$t('dispatch.rsvpTable.emptyRsvp.title'),
        content: self.$t('dispatch.rsvpTable.emptyRsvp.content')
      }
    },
    checkedAll: {
      get () {
        let self = this
        return self.$store.state.dispatch.checkedReservations.length ===
               self.$store.state.dispatch.rsvpInTable.length
      },
      set (value) {
        let self = this
        let rsvps = self.$store.state.dispatch.rsvpInTable
        let checkedItems = []
        if (value) {
          for (let i = 0; i < rsvps.length; i++) {
            checkedItems.push({
              id: rsvps[i].id,
              isPackage: rsvps[i].isPackage,
              status: rsvps[i].statusClass
            })
          }
        }
        self.$store.commit('dispatch/updateCheckedReservations', checkedItems)
      }
    },
    totalPages () { return this.$store.state.dispatch.rsvpPaging.totalPages },
    currentPage: {
      get () { return this.$store.state.dispatch.rsvpPaging.currentPage },
      set (value) { this.$store.commit('dispatch/setRsvpCurrentPage', value) }
    },
    rsvpSort () { return this.$store.state.dispatch.rsvpSort },
    rtgSuccess () { return this.$store.state.dispatch.readyToGo.success },
    showDriverPayment () { return this.$settings.get('DispatchShowDriverPayment') }
  },
  methods: {
    setScreenSize() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    pageBtn (isNext) {
      let self = this
      let pageChange = isNext ? 1 : -1
      if (isNext) {
        self.isLoadingNext = true
      } else {
        self.isLoadingBack = true
      }
      self.$store.commit('dispatch/setRsvpCurrentPage',
        self.$store.state.dispatch.rsvpPaging.currentPage + pageChange)
      self.loadPage()
    },
    loadPage () {
      let self = this
      // self.isPageLoading = true
      ApiDispatchReservation.getReservations(self, r => {
        // self.isPageLoading = false
        self.isLoadingBack = false
        self.isLoadingNext = false
        self.scrollLoading = false

        if (r.error) { return }

        // self.$plugins.smoothScroll.scrollTo(document.getElementById('rsvp-table-container'))
      }, true)
    },
    sort (order) {
      let self = this
      let existingOrder = self.rsvpSort.order
      let existingAsc = self.rsvpSort.asc
      let asc = existingAsc
      if (order === existingOrder) {
        asc = !existingAsc
      }

      self.$store.commit('dispatch/setRsvpSort', {
        order: order, asc: asc
      })

      self.isSorting = true
      self.$store.commit('dispatch/setRsvpCurrentPage', 1)
      ApiDispatchReservation.getReservations(self, r => {
        self.isSorting = false
        if (r.error) {
          return
        }
      }, true)
    },
    onScroll (event) {
      // console.log(event)
      let rsvpPaging = this.$store.state.dispatch.rsvpPaging
      if (this.scrollLoading || rsvpPaging.currentPage >= rsvpPaging.totalPages) { return }

      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      // console.log(event.target.scrollHeight - scrollAndView)
      if (event.target.scrollHeight - scrollAndView < 150) {
        this.scrollLoading = true
        this.$store.commit('dispatch/setRsvpCurrentPage', this.$store.state.dispatch.rsvpPaging.currentPage + 1)
        this.loadPage()
      }
    }
  },
  mounted() {
    this.setScreenSize()
  },
  watch: {
    rtgSuccess: function (value) {
      if (value) {
        this.$store.commit('dispatch/setReadyToGoSuccess', false)
        this.loadPage()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.reservations-table-container {
  position: absolute;
  width: 100%;
  /*height: calc(100% - 70px);*/
  height: calc(100% - 70px);
  overflow: auto;
}
.reservations-table-wrapper{
  display: block;
  height: 100%;
  width: 100%;
}
.infinity-loader{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: rgba(0,0,0, .6);
  color: #fff;
  transform-origin: bottom center;
  text-align: center;
  font-size: 18px;
  line-height: 40px;
}
table{
  border-collapse: collapse;
  width: 100%;
  display: block;
  overflow: auto;
  border-bottom: 1px solid rgba(0,0,0,0.2);
  padding-top: 47px;
  height: 100%;
  table-layout: fixed;
  /*&.has-paging{ height: calc(100% - 60px); }*/

  & thead{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: tables;
  }

  tbody{ display: block; }
  &.shrink{
    padding-top: 29px;
    tr { display: block; }
    .rc-1{
      width: 40px!important;
      padding-left: 15px;
    }
    .rc-2{ width: 40px!important; }
    .rc-3{ width: 40px!important; }
    .rc-4{ width: 65px!important; }
  }
}
.table-header{
  color: #8DA0A9;
  font-size: 12px;
  border: 1px solid rgba(0,0,0,0.3);
  background-color: #f5f5f5;

  & th{
    padding: 5px;

    &.sortable {
      cursor: pointer;
      text-decoration: underline;
      color: #333;
      transition: all 250ms;

      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    }

    & input{
      margin-top: 0;
      display: block;
      width: auto;
    }
  }
}

.empty-reservations{
  max-width: 450px;
  margin: 50px auto;
  text-align: center;
  width: 90%;

  & .title {
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  & .content{
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
    color: #777;
  }
}

.table-loader{
  position: relative;
  width: 100%;
  margin: 50px auto;
  text-align: center;

  & .loader-title{
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  & .loader-text{
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
    color: #777;
  }
}

table{
  .table-loader{
    width: 100%;
  }
  .tr-loader{
    width: 100%;
    display: inline-table;
  }
}

.paging {
  margin: 15px auto;
  width: 103px;
  opacity: 1;
  transition: all 250ms;

  &.disabled {
    pointer-events: none;
    opacity: 0.6;
  }

  & .page{
    display: inline-block;
    vertical-align: middle;
    width: auto;

    &:not(:first-child) {
      margin-left: -5px;
    }
  }

  & .page-btn {
    background-color: #f5f5f5;
    border: 1px solid rgba(0,0,0,0.25);
    color: #777;
    padding: 5px 5px;
    font-size: 12px;

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }

    & i { line-height: inherit; }

    &.back {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      border-right: 0;
    }

    &.next {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }

  & .page-number {
    border-radius: 0;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,0.3);
    line-height: inherit;
    font-size: 12px;
    margin: 0;
    width: 50px;
    font-weight: 700;
    padding: 5px 10px;
    color: #333;
    text-align: center;
    appearance: none;
    outline: 0;
    text-align-last:center;
    border-right: 0;
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

#rsvp-div {
  display: none;
}

@media only screen and (max-width: 430px) {
  #rsvp-table-container {
    // display: none;
    padding-top: 0;
  }

  table {
    tbody {
      padding-bottom: 100px;
    }
  }

  .table-loader {
    margin: 100px auto;
  }

  .infinity-loader {
    bottom: 47px;
    z-index: 1;
  }

  // #rsvp-div {
  //   display: block;
  //   height: calc(100% - 47px);
  //   overflow: auto;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/ReservationsTable.vue